import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'tw-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent {
  constructor(private router: Router) {}

  navigateToLogin() {
    this.router.navigate(['/']);
  }
}
